import { Td } from '@chakra-ui/react';

const Coalesce = ({ order, apiKey }) => {
  const keys = apiKey.split('|');
  const value = keys.map(key => order[key]).filter(el => !!el);
  return <Td>{value}</Td>;
};
export default Coalesce;
